import destinationSearch from "../../gol-api/destinationSearch";
import { AirportDestinations } from "../reducers/types/storage";
import * as actionTypes from "./actionTypes";

export const addAirportDestinations = (data) => {
  return {
    type: actionTypes.ADD_AIRPORT_DESTINATIONS,
    data,
  };
};

export const getDestinationByCode = (
  code: string,
  cachedDestinations: AirportDestinations,
  searchType = "flights"
) => {
  return async (dispatch) => {
    if (!code) {
      return;
    }

    // Handle multiple codes separated by "/" (e.g., "PRG/MUC/VIE")
    if (code.includes("/")) {
      const airportCodes = code.split("/");
      const foundDestinations = airportCodes
        .map((singleCode) =>
          cachedDestinations.find(({ Code }) => Code === singleCode)
        )
        .filter(Boolean);

      if (foundDestinations.length === airportCodes.length) {
        const combinedLabel = foundDestinations
          .map((dest) => dest.$t)
          .join(" / ");

        return {
          Code: code,
          Parent: foundDestinations[0]?.Parent || "",
          Country: foundDestinations[0]?.Country || "",
          State: foundDestinations[0]?.State || "",
          $t: combinedLabel,
        };
      }

      const loadedDestinations = await destinationSearch(code, searchType);
      dispatch(addAirportDestinations(loadedDestinations));
      const loadedDestination = loadedDestinations.find(
        ({ Code }) => Code === code
      );
      return loadedDestination;
    }

    const cachedDestination = cachedDestinations.find(
      ({ Code }) => Code === code
    );
    if (cachedDestination) {
      return cachedDestination;
    }

    const loadedDestinations = await destinationSearch(code, searchType);
    dispatch(addAirportDestinations(loadedDestinations));
    const loadedDestination = loadedDestinations.find(
      ({ Code }) => Code === code
    );

    return loadedDestination;
  };
};
